import { useControllableState } from '@radix-ui/react-use-controllable-state';

import { Popover } from '../../Popover';
import {
  MultiselectContextProvider,
  type MultiselectContextProviderProps,
  MultiselectPopoverContextProvider,
} from '../MultiselectInput.context';

interface MultiselectRootProps extends MultiselectContextProviderProps {
  popoverOpen?: boolean;
  onPopoverOpenChange?: (open: boolean) => void;
}

export const MultiselectRoot = ({
  children,
  popoverOpen,
  onPopoverOpenChange,
  ...props
}: MultiselectRootProps) => {
  const [open, onOpenChange] = useControllableState({
    prop: popoverOpen,
    onChange: onPopoverOpenChange,
    defaultProp: false,
  });

  const { disabled } = props;

  return (
    <MultiselectContextProvider {...props}>
      <MultiselectPopoverContextProvider
        open={open}
        onOpenChange={onOpenChange}
      >
        <Popover open={!disabled && open} onOpenChange={onOpenChange}>
          {children}
        </Popover>
      </MultiselectPopoverContextProvider>
    </MultiselectContextProvider>
  );
};
